interface getDisplayNameProps {
  firstName: string;
  lastName: string;
  countryCode: string;
}

export const formatName = ({
  firstName,
  lastName,
  countryCode,
}: getDisplayNameProps) => {
  return countryCode === '+82'
    ? `${lastName} ${firstName}`
    : `${firstName} ${lastName}`;
};
